import * as React from "react";
import { Button, Modal, Input, message } from "antd";
const { TextArea } = Input;
import { connect } from "react-redux";

interface ISynchTmallNoProps {
  // 同步淘宝订单
  importOrder: any;
  searchOrder: any;
}

// 同步淘宝订单
class SynchTmallNo extends React.Component<ISynchTmallNoProps, any> {
  state = { visible: false, value: "", disabled: true, isRequest: false };

  showModal = () => {
    this.setState({
      visible: true
    });
  };

  handleOk = e => {
    this.setState(
      {
        isRequest: true
      },
      () => {
        this.props.importOrder({
          number: this.state.value,
          callback: (data, res) => {
            if (data.error) {
              message.error(data.res.msg);
              this.setState({
                isRequest: false
              });
            } else {
              this.setState({
                visible: false,
                isRequest: false
              });
              // "同步淘宝订单成功"
              message.success(res.msg || "同步淘宝订单成功");
              this.props.searchOrder();
            }
          }
        });
      }
    );
  };

  handleCancel = e => {
    console.log(e);
    this.setState({
      visible: false,
      value: "",
      disabled: true,
      isRequest: false
    });
  };

  constructor(props: ISynchTmallNoProps) {
    super(props);
  }

  onChange = e => {
    const value = e.target.value.trim();
    let disabled = true;
    if (value) {
      disabled = false;
    }

    this.setState({
      value,
      disabled
    });
  };

  updateDisabled = () => {
    return this.state.disabled || this.state.isRequest;
  };

  render() {
    const buttonStyle = {
      backgroundColor: "#2b9fbd",
      borderColor: "#2b9fbd"
    };
    return (
      <div className="button-group-child">
        <Button type="primary" style={buttonStyle} onClick={this.showModal}>
          同步淘宝订单
        </Button>

        <Modal
          title="同步淘宝订单"
          visible={this.state.visible}
          destroyOnClose={true}
          keyboard={false}
          centered={true}
          onOk={this.handleOk}
          okButtonProps={{ disabled: this.updateDisabled() }}
          onCancel={this.handleCancel}
        >
          <TextArea
            placeholder="请输入淘宝订单"
            autosize={{ minRows: 10, maxRows: 16 }}
            onChange={this.onChange}
          />
        </Modal>
      </div>
    );
  }
}

const mapDispatch = dispatch => {
  return {
    importOrder: dispatch.orderInfo.importOrder
  };
};

export default connect(
  null,
  mapDispatch
)(SynchTmallNo);
